import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import collabReq from "../Assets/Img/collabReq.png";
import collaborateicon from "../Assets/Img/collaborateicon.png";
import "../Assets/css/influencer.css";
import axiosMain from "../http/axiosMain";

export default function CollaborationModal({
  open,
  setOpen,
  fetchCampaign,
  InfluencerDetailData,
  sender_user_id,
  receiver_user_id,
  campaignName,
}) {
  const [note, setNote] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showNoteSuccessModal, setShowNoteSuccessModal] = useState(false);
  const [error, setError] = useState(""); // Error state for validation

  // Extract campaign & brand ID safely
  const campaignId = InfluencerDetailData?.campaign_id;
  const brandId = InfluencerDetailData?.user_id;
  // console.log(InfluencerDetailData, "AAAA");
  const InfluencerUserInfo = JSON.parse(localStorage.getItem("user"));

  const InfluencersName = InfluencerUserInfo?.user?.first_name;
  // const 
  // API Call Function
  const fetchNotifications = async () => {
    try {
      const response = await axiosMain.post(
        "/api/notifications/notifications",
        {
          sender_user_id: sender_user_id, // Pass sender ID
          receiver_user_id: receiver_user_id, // Pass receiver ID
          message: `${`${InfluencersName}` +
            " " +
            "Influencer wants to collaborate on" +
            " " +
            `${campaignName}`
            }`,
        }
      );
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const sendCollabRequest = async (message) => {
    try {
      const response = await axiosMain.post("/api/v1/make-request", {
        campaign_id: campaignId,
        brand_id: brandId,
        message,
      });
      setOpen(false);
      setShowNoteSuccessModal(true);
      fetchCampaign();
      setTimeout(() => setShowNoteSuccessModal(false), 2000);
      fetchNotifications();
      console.log("API Response:", response.data);
    } catch (error) {
      console.error(
        "Error sending request:",
        error.response ? error.response.data : error.message
      );
    }
  };

  // Handle "Send Request without Note"
  const handleSendWithoutNote = async () => {
    console.log("Send Request without Note Clicked");
    await sendCollabRequest(""); // Send empty message
    setOpen(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  // Handle "Send Collab Request"
  const handleSendWithNote = async () => {
    await sendCollabRequest(note); // Send message with note
  };

  return (
    <>
      {/* First Modal - Main Collaboration Request */}
      <Modal show={open} onHide={() => setOpen(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="collab-title">
            You Can Customize This Collaboration Request{" "}
            <span className="collab-optional">(Optional)</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="collab-body-text">
            Spice up your pitch! Drop a quick line to show why you're the
            perfect match.
          </p>

          <div className="position-relative">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Increase your chances! A personal touch can go a long way in securing collaborations."
              className="note-input"
              value={note}
              onChange={(e) => {
                setNote(e.target.value);
                setError(""); // Clear error when user types
              }}
            />
          </div>

          {/* Error Message */}
          {error && <div className="error-message">{error}</div>}

          {/* Character count outside the box */}
          <div className="char-count-outside">{note.length}/100</div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          {/* <Button
            variant="light"
            className="send-collab-req"
            onClick={handleSendWithoutNote}
          >
            Send Request without Note
          </Button> */}
          <div></div>
          <Button className="send-req" onClick={handleSendWithNote}>
            Send Collab Request{" "}
            <img src={collaborateicon} alt="collaborate-icon" />
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Second Modal - Success Message (Without Note) */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Body className="success-modal-body text-center">
          <img src={collabReq} alt="Success" className="success-icon" />
          <p className="success-message">
            Collaboration Request sent without any Note!
          </p>
        </Modal.Body>
      </Modal>

      {/* Third Modal - Success Message (With Note) */}
      <Modal
        show={showNoteSuccessModal}
        onHide={() => setShowNoteSuccessModal(false)}
        centered
      >
        <Modal.Body className="success-modal-body text-center">
          <img src={collabReq} alt="Success" className="success-icon" />
          <p className="success-message">
            Collaboration Request sent successfully! <br />
            <strong>Note:</strong> "{note}"
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}
